var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-white footer border-top"},[_c('div',{staticClass:"d-flex align-items-center h-100"},[_c('div',{staticClass:"text-muted mx-auto"},[_vm._v("© "+_vm._s(_vm.year)+" The Owl Centre")])])])}
var staticRenderFns = []

export { render, staticRenderFns }